import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { List, ListItem, ListItemText } from '@mui/material';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function UpdateModal(props) {
    const [value, setValue] = React.useState(0);
    const [updateList, setUpdateList] = React.useState({
        "1.0.3": [
            'اضافه شدن دکمه برگشت در تمام مراحل لاگین',
            'اضافه شدن چرخ دنده نشان گذاری ها به منظور لینک شدن به مدیریت نشانه گذاری ها در نمایه',
            'اضافه شدن مودال ارتباطات',
            'اضافه شدن مودال امکانات پایش',
        ],
        "1.0.4": [
            "امکان حذف فیلتر ها",
            "رفع باگ در فیلتر مبلغ رهن و اجاره"
        ]
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value} onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable force tabs example"
                    className='tab-nav'
                    dir="rtl"
                >
                    {Object.keys(updateList).map((item) => {
                        return <Tab label={item} className='tab-nav-item' />
                    })}

                </Tabs>
            </Box> */}

            {Object.keys(updateList).map((item, index) => {
                return <CustomTabPanel value={value} index={index} key={index}>
                    <Box>
                        {
                            props.changesVersion?.additions.length ? <>
                                <Box>امکانات اضافی : </Box>
                                <List sx={{ direction: "rtl", color: "#228c2d" }}>
                                    {props.changesVersion?.additions.map((verItem, verIndex) => {
                                        return <ListItem sx={{ px: "5px!important" }} key={verIndex}>
                                            <ListItemText
                                                primary={`${verIndex + 1}. ${verItem}`}
                                                sx={{ textAlign: "right", fontSize: "13px" }}
                                            />
                                        </ListItem>
                                    })}
                                </List>
                            </> : ""}
                        {props.changesVersion?.bug_fix.length ? <><Box>رفع باگ ها : </Box>
                            <List sx={{ direction: "rtl", color: "#d03e3e" }}>
                                {props.changesVersion?.bug_fix.map((bugItem, bugIndex) => {
                                    return <ListItem sx={{ px: "5px!important" }} key={bugIndex}>
                                        <ListItemText
                                            primary={`${bugIndex + 1}. ${bugItem}`}
                                            sx={{ textAlign: "right", fontSize: "13px" }}
                                        />
                                    </ListItem>
                                })}
                            </List></> : ""}
                    </Box>
                </CustomTabPanel>
            })}
        </Box>
    );
}
